export default function convertSvgTransformToCss (transform) {
  if (typeof transform !== 'string') return '';

  // Matches any number of transform functions
  const transformFuncsRegex = /(\w+\((-?\d+\.?\d*e?-?\d*,? ?)+\))+/g;
  const transformFunctions = transform.match(transformFuncsRegex) || [];
  return transformFunctions.map(transformFunction => {
    const transformFunctionParts = transformFunction.match(/[\w.-]+/g) || [];
    const name = transformFunctionParts.shift();
    const params = transformFunctionParts;

    let returnVal = `${name}(`;
    switch (name) {
      case 'rotate':
        // rotate(<a> [<x> <y>])
        // <a> rotation in deg
        if (params.length >= 1) returnVal += `${params[0]}deg)`;
        break;
      default:
        returnVal = '';
        break;
    }
    return returnVal;
  }).join(' ');
}
